// The OWNER's view of their own nominee roster: /nominees, plural.
//
// nomineeApi.js (singular) is the other side of the same feature - the routes a NOMINEE
// calls to request a one-time password and open a vault they were designated for. Those
// are unauthenticated or nominee-token-scoped; every call here needs a full owner
// session. Same split as the server's two routers, kept deliberately so a reader never
// has to work out which caller a given function is for.
//
// Before migration 009 these went through dataApi.js as ordinary vault records in the
// NOMINEE_INFORMATION category. They are not vault records - they are other people's
// contact details, held under a consent the owner gave - and they now have a store, an
// API and a page of their own.
import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function getNominees() {
  const res = await apiFetch(`${API_BASE}/nominees`);
  return res.json();
}

export async function addNominee(nominee) {
  const res = await apiFetch(`${API_BASE}/nominees`, {
    method: 'POST',
    body: JSON.stringify(nominee),
  });
  return res.json();
}

export async function updateNominee(id, nominee) {
  const res = await apiFetch(`${API_BASE}/nominees/${id}`, {
    method: 'PUT',
    body: JSON.stringify(nominee),
  });
  return res.json();
}

export async function deleteNominee(id) {
  const res = await apiFetch(`${API_BASE}/nominees/${id}`, {
    method: 'DELETE',
  });
  return res.json();
}
